import { defineMessage } from '@lingui/core/macro';

export const Pages = {
    HOME: defineMessage({
        id: 'pages.home',
        message: 'Обзор',
    }),
    HTTP_MONITORS: defineMessage({
        id: 'pages.monitors',
        message: 'Мониторинг сайтов',
    }),
    SERVERS: defineMessage({
        id: 'pages.servers',
        message: 'Мониторинг серверов',
    }),
    HTTP_MONITOR_LOG: defineMessage({
        id: 'pages.monitorLog',
        message: 'Журнал мониторинга',
    }),
    HTTP_MONITOR_DETAILS: defineMessage({
        id: 'pages.monitorDetails',
        message: 'Монитор',
    }),
    SETTINGS: defineMessage({
        id: 'pages.settings',
        message: 'Настройки',
    }),
    TARIFFS: defineMessage({
        id: 'pages.tariffs',
        message: 'Тарифы',
    }),
    PAYMENTS: defineMessage({
        id: 'pages.payments',
        message: 'Платежи',
    }),
    PAYMENTS_USERS: defineMessage({
        id: 'pages.paymentsUsers',
        message: 'Платежи пользователей',
    }),
    USERS: defineMessage({
        id: 'pages.users',
        message: 'Пользователи',
    }),
    ADMIN_TARIFFS: defineMessage({
        id: 'pages.adminTariffs',
        message: 'Редактор тарифов',
    }),
    ADMIN_TARIFF_VARIANTS: defineMessage({
        id: 'pages.adminTariffVariants',
        message: 'Редактор пакетов',
    }),
    ADMIN_PAYMENTS: defineMessage({
        id: 'pages.adminPayments',
        message: 'Платежи пользователей',
    }),
    HTTP_INCIDENTS: defineMessage({
        id: 'pages.incidents',
        message: 'Инциденты мониторов',
    }),
    DOMAIN_INCIDENTS: defineMessage({
        id: 'pages.warnings',
        message: 'Инциденты доменов',
    }),
    STATUS_PAGES: defineMessage({
        id: 'pages.statusPages',
        message: 'Страницы статуса',
    }),
    SUPPORT: defineMessage({
        id: 'pages.support',
        message: 'Тех. поддержка',
    }),
    NEWS: defineMessage({
        id: 'pages.news',
        message: 'Новости',
    }),
    PROMOS: defineMessage({
        id: 'pages.promos',
        message: 'Акции',
    }),
    CITIES: defineMessage({
        id: 'pages.cities',
        message: 'Города',
    }),
    LOCATIONS: defineMessage({
        id: 'pages.location',
        message: 'Локации',
    }),
    USER_REPORTS: defineMessage({
        id: 'pages.reports',
        message: 'Отчёты',
    }),
    ANALYTICS: defineMessage({
        id: 'pages.analytics',
        message: 'Аналитика',
    }),
    ADMIN_PROMO_CODES: defineMessage({
        id: 'pages.adminPromoCodes',
        message: 'Промокоды',
    }),
    SERVER_DETAILS: defineMessage({
        id: 'pages.serverDetails',
        message: 'Сервер',
    }),
    SERVER_INCIDENTS: defineMessage({
        id: 'pages.serverIncidents',
        message: 'Инциденты серверов',
    }),
    MONITORING_GROUP: defineMessage({
        id: 'pages.monitoringGroup',
        message: 'Мониторинг',
    }),
    INCIDENTS_GROUP: defineMessage({
        id: 'pages.incidentsGroup',
        message: 'Инциденты',
    }),
    MENU_SITES: defineMessage({
        id: 'pages.menuSites',
        message: 'Сайты',
    }),
    MENU_SERVERS: defineMessage({
        id: 'pages.menuServers',
        message: 'Серверы',
    }),
    MENU_DOMAINS: defineMessage({
        id: 'pages.menuDomains',
        message: 'Домены',
    }),
    DOMAIN_MONITORS: defineMessage({
        id: 'pages.domainMonitors',
        message: 'Мониторинг доменов',
    }),
    DOMAIN_MONITOR_DETAILS: defineMessage({
        id: 'pages.domainMonitorDetails',
        message: 'Монитор домена',
    }),
    MENU_PORTS: defineMessage({
        id: 'pages.menuPorts',
        message: 'Порты',
    }),
    PORT_MONITORS: defineMessage({
        id: 'pages.portMonitors',
        message: 'Мониторинг портов',
    }),
    PORT_MONITOR_DETAILS: defineMessage({
        id: 'pages.portMonitorDetails',
        message: 'Монитор порта',
    }),
    PORT_INCIDENTS: defineMessage({
        id: 'pages.portIncidents',
        message: 'Инциденты портов',
    }),
} as const;